<template>
  <header class="c-header-guests">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-full is-6-desktop">
          <h1 class="c-header-guests__title is-size-3 has-text-weight-bold">
            Meus convidados
          </h1>

          <div class="c-header-guests__guests columns is-mobile is-desktop">
            <div class="column is-8-widescreen">
              <div class="card">
                <p
                  class="has-text-primary has-text-weight-bold is-uppercase is-flex title-card is-align-items-center"
                >
                  <base-icon
                    name="painel/check-circle-icon"
                    width="20"
                    height="20"
                  />
                  Confirmados
                </p>
                <p class="total-number">
                  {{ rsvpAmountConfirmedTotal }}
                </p>
                <p class="card-status">
                  Adultos: {{ rsvpAmountAdultsTotal }} | Crianças:
                  {{ rsvpAmountChildrenTotal }}
                </p>
              </div>
            </div>
            <div class="column is-8-widescreen">
              <div class="card">
                <p
                  class="is-size-6 has-text-grey has-text-weight-bold is-uppercase is-flex title-card is-align-items-center"
                >
                  <base-icon
                    name="painel/close-circle-icon"
                    width="20"
                    height="20"
                  />
                  Cancelados
                </p>
                <p class="total-number">
                  {{ rsvpAmountCancelledTotal }}
                </p>
              </div>
            </div>
            <div class="column is-8-widescreen">
              <div class="card">
                <p
                  class="is-size-6 has-text-grey has-text-weight-bold is-uppercase is-flex title-card is-align-items-center"
                >
                  <base-icon name="painel/info-icon" width="20" height="20" />
                  Pendentes
                </p>
                <p class="total-number">
                  {{ rsvpAmountMaybeTotal }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="column has-text-right-tablet">
          <a
            v-if="whatsAppLink"
            :href="whatsAppLink"
            target="_blank"
            class="button is-neutral-outlined button-whatsapp is-flex-mobile"
          >
            <base-icon name="painel/whatsapp-icon" />
            Pedir confirmação
          </a>
          <router-link
            :to="{ name: 'rsvp-configuracoes' }"
            class="button is-support button-configs"
          >
            <base-icon name="painel/setting-icon" />
            <strong>Configurações</strong>
          </router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import isMobileBrowser from '@/plugins/detect-mobile-browser'

export default {
  computed: {
    ...mapGetters({
      wedSiteInfo: 'app/getWedSiteInfo',
      getRsvpConfigs: 'getRsvpConfigs',
      rsvpAmountAdultsTotal: 'rsvpAmountAdultsTotal',
      rsvpAmountChildrenTotal: 'rsvpAmountChildrenTotal',
      rsvpAmountConfirmedTotal: 'rsvpAmountConfirmedTotal',
      rsvpAmountCancelledTotal: 'rsvpAmountCancelledTotal',
      rsvpAmountMaybeTotal: 'rsvpAmountMaybeTotal',
    }),

    whatsAppLink() {
      let link = isMobileBrowser() ? 'whatsapp://' : 'https://web.whatsapp.com/'
      link +=
        'send?text=Sua presença é muito importante para nós no nosso grande dia. Por favor, confirme sua presença clicando nesse link: '

      return this.wedSiteInfo && this.wedSiteInfo.site_url
        ? `${link}${this.wedSiteInfo.site_url}/#/rsvp`
        : ''
    },
  },
}
</script>

<style lang="scss">
.c-header-guests {
  padding: 3em 1em;
  background-color: $white;
  color: $neutraldarkest;

  &__title {
    margin-bottom: 1em;
  }

  &__guests {
    margin-bottom: 2em;
    @media screen and (max-width: $desktop) {
      overflow: auto;
      scrollbar-width: none;
    }
    .card {
      min-width: 253px;
      height: 100%;
      border: 1px solid #dde7f1 !important;
      padding: 24px;
      border-radius: 16px;
      box-shadow: 0px 10px 8px 0px rgba(93, 117, 141, 0.05);

      .title-card {
        gap: 0.5rem;
        line-height: 100%;
      }
      .total-number {
        color: $neutral;
        font-size: 2.14519rem;
        font-weight: 800;
        margin: 1rem 0;
        line-height: 100%;
      }
      .card-status {
        color: $neutral;
        font-size: 18px;
        line-height: 100%;
      }
    }
  }

  .button .svg-icon {
    margin-right: 8px;
  }

  .button-whatsapp {
    margin-bottom: 24px;
    @media screen and (min-width: $tablet) {
      margin-right: 16px;
      margin-bottom: 0;
    }
  }
}
</style>
